<div id="confirm-division-change" class="evir-font-default">
    <div mat-dialog-content>
            <mat-icon>warning</mat-icon>
            <p>You are about to override and clear previously selected zones in this rule.</p>
    </div>
    <div
        mat-dialog-actions
    >
        <app-action-button
            cdkFocusInitial
            title="Cancel"
            (buttonClicked)="cancelDivisionChange()"
        ></app-action-button>
        <app-action-button
            title="Confirm"
            (buttonClicked)="applyDivisionChange()"
        ></app-action-button>
    </div>

</div>
